<template>
  <div>
    <site-header />
    <main class="policy-page">
      <section class="page-heading policy-hero">
        <p>Updated April 1, 2025</p>
        <h1>Return Policy</h1>
        <span>Important information about returns, gift cards, store credits, rewards, exchanges, and refunds.</span>
      </section>

      <section class="shipping-policy">
        <div class="policy-grid">
          <article>
            <h3>Important Return Notice</h3>
            <p>As a result of a change in ownership, returns, gift cards, store credits, and rewards issued before May 1, 2025 are no longer accepted on this site.</p>
          </article>
          <article>
            <h3>30-Day Return Window</h3>
            <p>Eligible items may be returned within 30 days from receipt for a refund. Refunds are credited to the original form of payment for the net price after discounts or coupons.</p>
          </article>
          <article>
            <h3>Return Fees</h3>
            <p>Original shipping costs are not refunded. Returned merchandise will incur a $9.99 return shipping fee per return, deducted from the refund amount when a prepaid label is used.</p>
          </article>
          <article>
            <h3>Item Condition</h3>
            <p>Returned merchandise must be unworn, undamaged, unwashed, sealable, and in the same condition as received, with original tags attached and all packaging materials included.</p>
          </article>
          <article>
            <h3>Beauty Products</h3>
            <p>Beauty products may be returned only if unopened, unused, and with the original cellophane fully intact. Returned merchandise must be in saleable condition.</p>
          </article>
          <article>
            <h3>Restocking Fees</h3>
            <p>Furniture, mattresses, wall art, mirrors, lamps, and artificial trees may incur a 15% restocking fee of the purchase price in addition to the $9.99 return shipping fee.</p>
          </article>
          <article>
            <h3>Non-Returnable Items</h3>
            <p>Final sale items, clearance items, assembled items, altered apparel, special orders, cloth face coverings, perishable items, personalized items, monogrammed items, intimates, swimsuits, undergarments, and individual parts of bundles are not returnable.</p>
          </article>
          <article>
            <h3>Fee Waivers</h3>
            <p>Return shipping or restocking fees may be waived if the item was damaged during initial shipping, an incorrect item was shipped, or a defective item was shipped.</p>
          </article>
          <article>
            <h3>Exchange Policy</h3>
            <p>Direct exchanges are not currently offered. To get a different size or color, place a new order. Once the returned item is received and inspected, a refund will be issued to the original payment method.</p>
          </article>
          <article>
            <h3>How to Return</h3>
            <p>Use the return process provided on the site to request a return authorization and prepaid shipping label. Multiple items from a single order may require separate labels.</p>
          </article>
          <article>
            <h3>Multiple Orders</h3>
            <p>Orders cannot be combined into a single return shipment. Use the individual return label provided for each order so each return can be processed separately.</p>
          </article>
          <article>
            <h3>Own Shipping Label</h3>
            <p>If using your own shipping label, you are responsible for tracking the return and providing tracking details through customer service. Refunds are issued only after returned items are received and inspected.</p>
          </article>
        </div>
      </section>
    </main>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'ReturnPolicy',
  components: { SiteHeader, SiteFooter }
}
</script>
